var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4406 12.8499L10.6864 9.09564C10.3122 8.72146 9.70104 8.72146 9.32686 9.09564L5.5726 12.8374L5.38551 12.6878C5.06122 12.4383 4.78682 12.1639 4.53737 11.8521L4.3877 11.665L8.14196 7.91073C8.60345 7.44925 9.20214 7.19979 9.8133 7.1499C9.87566 7.1499 9.93802 7.1499 10.0004 7.1499C10.0627 7.1499 10.1251 7.1499 10.1875 7.1499C10.7986 7.19979 11.3849 7.44925 11.8588 7.91073L15.6131 11.665L15.4634 11.8521C15.214 12.1514 14.9396 12.4383 14.6277 12.6878L14.4406 12.8374V12.8499Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.2d17e6ccc1d33e58f8be11b74d32b321.svg";
export { ForwardRef as ReactComponent };